import businessHours from "./businessHours.json";
import dateList from "./dateList.json";
import cliList from "./cliList.json";
import inboundList from "./inboundList.json";
import queues from "./queues.json";
import audioAnnouncements from "./audioAnnouncements.json";

const callFlowItems = {
  businessHours,
  dateList,
  cliList,
  inboundList,
  queues,
  audioAnnouncements,
};

export default callFlowItems;
